export default {
    namespaced: true,
    state: {
        list: [],
    },
    getters: {
        getList(state) {
            return state.list;
        },
    },
    mutations: {
        add(state, message) {
            state.list.push(message);
        },
        remove(state) {
            state.list.shift();
        },
    },
    actions: {
        show(context, { text, type }) {
            context.commit('add', { text, type });

            setTimeout(() => {
                context.commit('remove');
            }, 5000);
        },
    },
};
